import * as apiUrl from './apiUrl';
import { get } from './apiHelper';
import MockData from 'mock.json'

export const GetComplaintsForOrganizations = async (nilonLevelId?: string) =>
    get(apiUrl.GET_COMPLAINTS_FOR_ORGANIZATIONS, { nilonLevelId }).then(response => response);

export const GetComplaintDetails = async (complaintEntityId: string) =>
    get(apiUrl.GET_COMPLAINTS_DETAILS, { complaintEntityId }).then(response => response);

export const GetTopComplaintSubjects = async (subjectId?: string) =>
    get(apiUrl.GET_TOP_COMPLAINTS_SUBJECTS, { subjectId })
        .then(response => response);

export const GetSubjectDetails = async (subjectId: string) =>
    get(apiUrl.GET_SUBJECT_DETAILS, { subjectId }).then(response => response);

export const GetNilonLevelsDropDownList = async () => get(apiUrl.GET_NILON_LEVELS_DROP_DOWN_LIST).then(response => response);

export const GetSubjectsDropDownList = async () => get(apiUrl.GET_SUBJECTS_DROP_DOWN_LIST).then(response => response);

export const GetLocalAuthorityDropDownList = async () => get(apiUrl.GET_LOCAL_AUTHORITY_DOWN_LIST).then(response => response);

export const GetCitiesDropDownList = async () => get(apiUrl.GET_CITIES_DROP_DOWN_LIST).then(response => response);

export const GetComplaintsAmountDropDownList = async () => get(apiUrl.GET_COMPLAINTS_AMOUNT_DOWN_LIST).then(response => response);

export const GetComplaintAboutAuthorities = async (authorityId?: string) =>
    get(apiUrl.GET_COMPLAINI_ABOUT_AUTHORITIES, { authorityId })
        .then(response => response);

export const GetLocalAuthoritiesDetails = async (localAuthority: string) =>
    get(apiUrl.GET_LOCAL_AUTHORITIES_DETAILS, { localAuthority }).then(response => response);

export const GetDistrictsForMap = async () =>
    get(apiUrl.GET_DISTRICTS_FOR_MAP).then(response => response);

export const GetDistrictDetails = async (districtEntityId: string) =>
    get(apiUrl.GET_DISTRICT_DETAILS, { districtEntityId }).then(response => response);

export const GetDistributionOfComplaints = async (nilonCategoryId?: string, fromSkip?: number, numOfRow?: number, nilonId?: string) =>
    get(apiUrl.GET_DISTRIBUTION_OF_COMPLAINTS, { nilonCategoryId, fromSkip, numOfRow, nilonId }).then(response => response);

export const GetComplaintAmount = async (complaintEntityId?: string) =>
    get(apiUrl.GET_COMPLAINT_AMOUNT, { complaintEntityId }).then(response => response);

export const GetComplaintsByGender = async () => get(apiUrl.GET_COMPLAINTS_BY_GENDER).then(response => response);

export const GetHandlingComplaints = async (complaintEntityId?: string) =>
    get(apiUrl.GET_HANDLING_COMPLAINTS, { complaintEntityId }).then(response => response);

export const GetComplaintSubjectsGenderGap = async () => get(apiUrl.GET_COMPLAINT_SUBJECTS_GENDER_GAP).then(response => response);

export const GetCities = async (cityId?: string) => get(apiUrl.GET_CITIES, { cityId }).then(response => response);

export const GetComplaintsByHowComplaintsAreReceived = async () => get(apiUrl.GET_COMPLAINTS_BY_HOW_COMPLAINTS_ARE_RECEIVED).then(response => response);

export const GetTopRootSubjectsGenderGapDetail = async (subjectId: string) =>
    get(apiUrl.GET_COMPLAINT_SUBJECTS_GENDER_GAP_DETAIL, { subjectId }).then(response => response);

export const GetPopulation = async () => get(apiUrl.GET_POPULATION).then(response => response);